"use client";

import { useNotebookContext } from "../../../hooks/useNotebook";
import { SourceViewer } from "../sources/source-viewer";

export function SourceInterface() {
  const { currentPage, navigatePage } = useNotebookContext();
  const value =
    currentPage.type === "source"
      ? currentPage.value
      : currentPage.type === "source_highlight" ||
        currentPage.type === "source_highlight_category"
      ? currentPage.source
      : null;
  if (!value) return null;
  return (
    <SourceViewer
      document={value}
      onBack={() => navigatePage({ type: "chat" })}
    />
  );
}
